import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/sort-comp */
import React from 'react';
import Autosuggest from 'react-autosuggest';
import Input from '../input/Input';
import { ThemeContext } from '../ui-configurator/UIConfigurator';
import * as styles from './AutoComplete.style';
import { ICON_CLOSE } from '../../icons';
export const DEFAULT_ERROR_MESSAGE = 'Errore durante il caricamento...scrivi e riprova';
/** @deprecated use AutoCompleteV2 instead */
export class AutoComplete extends React.Component {
  static contextType = ThemeContext;
  state = {
    loadedSuggestions: [],
    loading: null,
    error: null,
    inputValue: null
  };
  static defaultProps = {
    dataRef: 'autocomplete',
    minLength: 3
  };
  renderSuggestion = (suggestion, params) => {
    const {
      printSuggestion,
      render
    } = this.props;
    const {
      isHighlighted
    } = params;
    return /*#__PURE__*/React.createElement(_StyledDiv, {
      $isHighlighted: isHighlighted,
      $_css: styles.suggestion
    }, render && render.suggestion ? render.suggestion(suggestion, params) : printSuggestion(suggestion));
  };
  renderInputComponent = _ref => {
    let {
      ref,
      ...inputProps
    } = _ref;
    const {
      id,
      disabled,
      icon,
      dataRef
    } = this.props;
    const {
      loading
    } = this.state;
    const wrappedRef = inputRef => {
      this.inputRef = inputRef;
      ref(inputRef);
    };
    const inputIcon = inputProps.value ? ICON_CLOSE : icon;
    const showInputIcon = disabled ? undefined : inputIcon;
    return /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
      id: `${id}-input`,
      disabled: disabled,
      ref: wrappedRef,
      dataRef: `${dataRef}-input`,
      icon: showInputIcon,
      onClickIcon: inputProps.value ? this.clearInput : undefined,
      loading: loading !== null
    }));
  };
  renderSuggestionsContainer = _ref2 => {
    let {
      containerProps,
      children
    } = _ref2;
    const {
      render,
      dataRef
    } = this.props;
    const {
      error
    } = this.state;
    return /*#__PURE__*/React.createElement(_StyledDiv2, _extends({}, containerProps, {
      $_css2: styles.suggestionList
    }), error ? /*#__PURE__*/React.createElement(_StyledDiv3, {
      "data-ref": `${dataRef}-suggestions-error`,
      $_css3: styles.suggestionError
    }, render && render.errorMessage ? render.errorMessage(error) : DEFAULT_ERROR_MESSAGE) : /*#__PURE__*/React.createElement(React.Fragment, null, render && render.suggestionsListHeader && /*#__PURE__*/React.createElement("header", {
      "data-ref": `${dataRef}-suggestions-container-header`
    }, render.suggestionsListHeader()), children, render && render.suggestionsListFooter && /*#__PURE__*/React.createElement("footer", {
      "data-ref": `${dataRef}-suggestions-container-footer`
    }, render.suggestionsListFooter())));
  };
  shouldRenderSuggestions = value => {
    const {
      error
    } = this.state;
    const {
      minLength = 3
    } = this.props;
    return error !== null || value.trim().length >= minLength;
  };
  clearInput = event => {
    const {
      onChange
    } = this.props;
    if (onChange) {
      /*
       * Unfortunately we can't dispatch an event from dom.
       * We need a real change event for external
       * clean communications, so overwrite target and its value
       */
      const customEvent = event;
      customEvent.target = this.inputRef;
      customEvent.target.value = '';
      onChange(customEvent);
    }
    this.setState({
      inputValue: ''
    });
  };
  internalOnChange = (event, _ref3) => {
    let {
      newValue,
      method
    } = _ref3;
    const {
      onChange
    } = this.props;
    this.setState({
      inputValue: newValue
    });

    /*
     * Unfortunately Autosuggest doesn't fake suggestion div interaction as
     * they were input changes.
     * We need a real change event for external
     * clean communications, so overwrite target and its value
     */
    if (method !== 'type') {
      event.target = this.inputRef;
      event.target.value = newValue;
    }
    if (onChange) {
      onChange(event);
    }
  };
  internalOnSuggestionSelected = (event, data) => {
    const {
      onSuggestionSelected
    } = this.props;

    // we need to manage internal error state cause a fake suggestion is pushed into
    // array, as AutoSuggest doesn't render empty suggestions, even if we force him
    const {
      error
    } = this.state;
    if (!error && onSuggestionSelected) {
      onSuggestionSelected(data.suggestion);
    }
  };
  internalOnSuggestionsFetchRequested = async request => {
    const {
      suggestions
    } = this.props;

    // no need to fetch anything, suggestions won't change
    if (typeof suggestions !== 'function') {
      return;
    }

    // we save promise in state so that we compare latest promise
    // with the one in our asynchronous function closure
    // so that we ignore previously resolved/rejected promises
    // and set state only on latest one
    const promise = suggestions(request.value);
    const setStateOnCurrentLoadingPromise = (result, error) => {
      this.setState(prevState => {
        // long-running promises could overlap, ignore all promises that aren't equal to latest
        if (prevState.loading !== promise) {
          return null;
        }
        return {
          loading: null,
          error,
          loadedSuggestions: result
        };
      });
    };
    this.setState({
      loading: promise,
      loadedSuggestions: []
    });
    try {
      const result = await promise;
      setStateOnCurrentLoadingPromise(result, null);
    } catch (error) {
      // we set error into loaded suggestions because otherwise
      // autosuggest doesn't call render suggestions if array is empty
      // ...maybe we will completely redo it at some point
      setStateOnCurrentLoadingPromise([{}], error);
    }
  };
  internalGetSuggestionValue = suggestion => {
    const {
      printSuggestion
    } = this.props;

    // we need to manage internal error state cause a fake suggestion is pushed into
    // array, as AutoSuggest doesn't render empty suggestions, even if we force him
    const {
      error
    } = this.state;
    if (error) {
      return '';
    }
    return printSuggestion(suggestion);
  };
  internalOnSuggestionClearRequested = () => this.setState({
    loadedSuggestions: []
  });
  render() {
    const {
      id,
      suggestions,
      // Remove onSuggestionSelected from props passed to Input
      // to avoid React warnings
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSuggestionSelected,
      value: initialValue,
      ...rest
    } = this.props;
    const {
      loadedSuggestions,
      inputValue
    } = this.state;
    const autosuggestTheme = {
      container: {
        position: 'relative'
      },
      suggestionsContainer: {
        display: 'none'
      },
      suggestionsContainerOpen: {
        display: 'block',
        // eslint-disable-next-line react/destructuring-assignment
        zIndex: this.context?.zIndex?.popover ?? 999
      }
    };
    const shownSuggestions = typeof suggestions !== 'function' ? suggestions : loadedSuggestions;
    const value = inputValue ?? initialValue?.toString() ?? '';
    const inputProps = {
      ...rest,
      onChange: this.internalOnChange,
      value
    };
    return /*#__PURE__*/React.createElement(Autosuggest, {
      id: id,
      theme: autosuggestTheme,
      focusInputOnSuggestionClick: true,
      highlightFirstSuggestion: true,
      suggestions: shownSuggestions,
      inputProps: inputProps,
      getSuggestionValue: this.internalGetSuggestionValue,
      renderSuggestion: this.renderSuggestion,
      renderInputComponent: this.renderInputComponent,
      renderSuggestionsContainer: this.renderSuggestionsContainer,
      onSuggestionsFetchRequested: this.internalOnSuggestionsFetchRequested,
      onSuggestionSelected: this.internalOnSuggestionSelected,
      onSuggestionsClearRequested: this.internalOnSuggestionClearRequested,
      shouldRenderSuggestions: this.shouldRenderSuggestions
    });
  }
}
export default AutoComplete;
var _StyledDiv = _styled("div").withConfig({
  displayName: "AutoComplete___StyledDiv",
  componentId: "sc-nyk4ya-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "AutoComplete___StyledDiv2",
  componentId: "sc-nyk4ya-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "AutoComplete___StyledDiv3",
  componentId: "sc-nyk4ya-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=AutoComplete.js.map